import styled from 'styled-components';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import _ from 'lodash';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { ReturnExchangesApi } from '../../../../../../../apis/ReturnExchangesApi';
import { useFetcher } from '../../../../fetcher/useFetcher';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';
import { useEffect, useState } from 'react';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import { CustomLabelInput } from '../../../../../../../components/input/CustomLabelInput';
import { customToast } from '../../../../../../../components/toast/custom-react-toastify/v1';
import { useProductOptionsValueContextHook } from '../../../../contexts/ProductOptionsContext';
import { ProductOptionsApi } from '../../../../../../../apis/ProductOptionsApi';
import { GlobalWegetProductOptionModal } from '../../../../../../../global-wegets/global-weget-product-option-modal';

const StyledTableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;

  .info-box{
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 12px;
    font-weight: 600;
  }
`

const StyledModalHeader = styled.div`
    padding: 10px;
`;

const StyledModalBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    input{
        border: 1px solid #dee2e6;
    }

    .optionCodeButton{
        background-color: #333;
        color: #fff;
        border-radius: 3px;
        border:none;
        padding: 0 10px;
        font-weight: 600;
        cursor: pointer;
    }

    .product-info-box{
        border: 1px solid #dee2e6;
        padding:10px;
        border-radius: 5px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .label{
            font-weight: 600;
            color:#333;
        }

        .content{
            padding-left: 5px;
            margin-top:5px;

            & .package{
                font-size: 10px;
                border-radius: 3px;
                background: var(--greenColor1-light);
                color: var(--greenColor1);
                padding: 3px 5px;
                display: inline-block;
            }
        }
    }
`;

const StyledModalFooter = styled.div`
    padding: 10px;

    button{
        border-radius: 3px;
        background-color: var(--blueColor1);
        color: #fff;
        font-weight: 600;
        border:none;
    }
`;

export function TdCollectionProductInfo({
    returnExchange
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();

    const productOptionsValueContextHook = useProductOptionsValueContextHook();
    const productOptions = productOptionsValueContextHook?.productOptions;
    const productOption = productOptions?.find(option => option.code === returnExchange?.collectionOptionCode);

    const [editReturnExchangeQuantityModalOpen, setEditReturnExchangeQuantityModalOpen] = useState(false);

    const handleReqChange = async (collectionOptionCode, returnExchangeQuantity, inspectionPassedQuantity) => {
        const editableData = _.cloneDeep(returnExchange);

        editableData.collectionOptionCode = collectionOptionCode;
        editableData.returnExchangeQuantity = Number(returnExchangeQuantity);
        editableData.inspectionPassedQuantity = Number(inspectionPassedQuantity);

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }
        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().updateList({
            headers: headers,
            body: {
                returnExchanges: [editableData]
            }
        });

        if (response?.content) {
            await fetcher.fetchReturnExchanges();
            setEditReturnExchangeQuantityModalOpen(false);
        }
        CustomBackdropController().hideBackdrop();
    }
    return (
        <>
            <StyledTableCell>
                <div className='info-box'>
                    <div><span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={(e) => { e.stopPropagation(); setEditReturnExchangeQuantityModalOpen(true); }}>상품명: {productOption?.product?.name || '-'} <span>🛠️</span></span></div>
                    <div><span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={(e) => { e.stopPropagation(); setEditReturnExchangeQuantityModalOpen(true); }}>옵션명: {productOption?.name || '-'} <span>🛠️</span></span></div>
                    <div><span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={(e) => { e.stopPropagation(); setEditReturnExchangeQuantityModalOpen(true); }}>회수수량: <span style={{ color: 'var(--redColor1)' }}>{returnExchange?.returnExchangeQuantity}</span> <span>🛠️</span></span></div>
                    <div><span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={(e) => { e.stopPropagation(); setEditReturnExchangeQuantityModalOpen(true); }}>정상제품수량: <span style={{ color: 'var(--greenColor1)' }}>{returnExchange?.inspectionPassedQuantity}</span> <span>🛠️</span></span></div>
                </div>
            </StyledTableCell>

            {editReturnExchangeQuantityModalOpen &&
                <EditReturnExchangeQuantityModal
                    open={editReturnExchangeQuantityModalOpen}
                    onClose={() => setEditReturnExchangeQuantityModalOpen(false)}
                    returnExchange={returnExchange}
                    onReqChange={handleReqChange}
                />
            }
        </>
    );
}

function EditReturnExchangeQuantityModal({
    open,
    onClose,
    returnExchange,
    onReqChange
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const [editableReturnExchange, setEditableReturnExchange] = useState(_.cloneDeep(returnExchange));
    const [productInfo, setProductInfo] = useState({
        productName: '',
        optionName: '',
        packageYn: 'n'
    });
    const [productOptionSelectModalOpen, setProductOptionSelectModalOpen] = useState(false);


    useEffect(() => {
        if (!editableReturnExchange?.collectionOptionCode) {
            return;
        }

        handleReqFetchProductOptions();
    }, [editableReturnExchange?.collectionOptionCode])

    const handleReqFetchProductOptions = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        CustomBackdropController().showBackdrop();
        const response = await ProductOptionsApi().searchListByOptionCodes({
            headers: headers,
            body: {
                optionCodes: [editableReturnExchange?.collectionOptionCode]
            }
        });

        if (response?.content && response?.content.length > 0) {
            setProductInfo({
                productName: response?.content[0]?.product?.name,
                optionName: response?.content[0]?.name,
                packageYn: response?.content[0]?.packageYn
            });
        }
        CustomBackdropController().hideBackdrop();
    }

    const handleChangeValue = (e) => {
        const value = e.target.value;
        const name = e.target.name;
        setEditableReturnExchange(prev => {
            return {
                ...prev,
                [name]: value
            }
        });
    }

    const handleAutoComplete = () => {
        setEditableReturnExchange(prev => {
            return {
                ...prev,
                collectionOptionCode: editableReturnExchange?.releaseOptionCode
            }
        })
    }

    const handleSelectProductOption = (item) => {
        setEditableReturnExchange(prev => {
            return {
                ...prev,
                collectionOptionCode: item?.productOptionCode
            }
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!editableReturnExchange?.collectionOptionCode) {
            customToast.error('교환상품 옵션코드를 선택해주세요.');
            return;
        }
        if (editableReturnExchange?.returnExchangeQuantity < 0 || editableReturnExchange?.returnExchangeQuantity > 999999) {
            customToast.error('회수수량은 0~999999 사이의 숫자만 입력 가능합니다.');
            return;
        }

        if (editableReturnExchange?.inspectionPassedQuantity < 0 || editableReturnExchange?.inspectionPassedQuantity > 999999) {
            customToast.error('정상제품수량은 0~999999 사이의 숫자만 입력 가능합니다.');
            return;
        }

        onReqChange(editableReturnExchange?.collectionOptionCode, editableReturnExchange?.returnExchangeQuantity <= 0 ? 0 : editableReturnExchange?.returnExchangeQuantity, editableReturnExchange?.inspectionPassedQuantity <= 0 ? 0 : editableReturnExchange?.inspectionPassedQuantity);
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledModalHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            회수 상품정보 변경
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => onClose()} />
                    </CustomDialog.Header>
                </StyledModalHeader>
                <form onSubmit={handleSubmit}>
                    <StyledModalBody>
                        <CustomBlockButton
                            type='button'
                            className='optionCodeButton'
                            onClick={handleAutoComplete}
                        >
                            출고 상품과 동일
                        </CustomBlockButton>
                        <div className='product-info-box'>
                            <div>
                                <div className='label'>교환상품 옵션코드</div>
                                <div className='content'><span style={{ cursor: 'pointer', textDecoration: 'underline' }} onClick={() => setProductOptionSelectModalOpen(true)}>{editableReturnExchange?.collectionOptionCode || '선택'}</span></div>
                            </div>
                            <div>
                                <div className='label'>교환상품명</div>
                                <div className='content'>{productInfo?.productName || '옵션코드 미지정'}</div>
                            </div>
                            <div>
                                <div className='label'>교환옵션명</div>
                                <div className='content'>{productInfo?.optionName || '옵션코드 미지정'} {productInfo?.packageYn === 'y' && <span className='package'>패키지</span>}</div>
                            </div>
                        </div>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='number'
                                onChange={handleChangeValue}
                                name='returnExchangeQuantity'
                                value={editableReturnExchange?.returnExchangeQuantity || ''}
                            />
                            <CustomLabelInput.Label style={{ color: 'var(--redColor1)' }}>*회수수량</CustomLabelInput.Label>
                        </CustomLabelInput>
                        <CustomLabelInput>
                            <CustomLabelInput.Input
                                type='number'
                                onChange={handleChangeValue}
                                name='inspectionPassedQuantity'
                                value={editableReturnExchange?.inspectionPassedQuantity || ''}
                            />
                            <CustomLabelInput.Label style={{ color: 'var(--greenColor1)' }}>*정상제품수량</CustomLabelInput.Label>
                        </CustomLabelInput>
                    </StyledModalBody>
                    <StyledModalFooter>
                        <CustomBlockButton
                            type='submit'
                        >적용</CustomBlockButton>
                    </StyledModalFooter>
                </form>
            </CustomDialog>

            {
                productOptionSelectModalOpen &&
                <GlobalWegetProductOptionModal
                    open={productOptionSelectModalOpen}
                    onClose={() => setProductOptionSelectModalOpen(false)}
                    onSelectItem={(item) => handleSelectProductOption(item)}
                />
            }
        </>
    );
}